if (!customElements.get('mega-alternative')) {
  class AlternateMega extends HTMLElement {
    constructor() {
      super();
      this.controls = this.querySelectorAll('.mega-alt__controls > .mega-menu__link[data-content]')
      this.content = this.querySelectorAll('.mega-alt__content .mega-alt__item[data-control]')
      
      if(this.controls.length != this.content.length || this.controls.length == 0 || this.content.length == 0) return //matching items, not zero

      //attach event listeners

      this.controls.forEach(control => {
        // control.addEventListener('click', this.handleControlClick.bind(this))
        control.addEventListener('mouseenter', this.handleControlClick.bind(this))
      })

    }

    handleControlClick(e){
      e.preventDefault()
      const control = e.currentTarget
      const target_index = control.dataset.content
      
      this._showContent(target_index)
      this._setActiveControl(target_index)
      
    }

    _showContent(index) {
      const target_content = this.querySelector(`.mega-alt__content .mega-alt__item[data-control="${index}"]`)
      const visible_content = this.querySelector(`.mega-alt__content .mega-alt__item.in-view`)

      if(!target_content) return

      visible_content?.classList.remove('in-view')
      target_content.classList.add('in-view') //show target

    }

    _setActiveControl(index) {
      const active_control = this.querySelector('.mega-alt__controls > .mega-menu__link.mega-menu__link--active')
      const target_control = this.querySelector(`.mega-alt__controls > .mega-menu__link[data-content="${index}"]`)

      if(!target_control) return

      active_control?.classList.remove('mega-menu__link--active')
      target_control.classList.add('mega-menu__link--active') //show target
    }

  }
    
  customElements.define('mega-alternative', AlternateMega);
}